var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('el-button',{attrs:{"type":"primary","plain":"","size":"small"},on:{"click":_vm.showConfirm}},[_vm._v(" Envoyer à Mailchimp ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }